import { Injectable } from '@angular/core';
import { HubConnection } from '@aspnet/signalr';
import * as signalR from '@aspnet/signalr';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TwoOptionModalComponent } from 'projects/common/src/app/components/two-option-modal/two-option-modal.component';
import { ITwoOptionModal } from 'projects/common/src/app/interfaces/components';
import { CommunicationSecurityService } from 'src/app/services/communication';
import { TokenService } from './parameters';
import { CacheService } from 'projects/common/src/app/services';
import { AuthenticationService } from './authentication.service';
import { UrlBuilderService } from 'projects/communication/src/app/services';

@Injectable({
  providedIn: 'root',
})
export class SignalRService {
  public hubLoginConnection: HubConnection | undefined;
  private baseUrl: string;

  constructor(
    private modalService: NgbModal,
    private communicationSecurityService: CommunicationSecurityService,
    private tokenService: TokenService,
    private authenticationService: AuthenticationService,
    private cacheService: CacheService,
    private urlBuilder: UrlBuilderService,
  ) {
    this.baseUrl = `${environment.securityBasePath}`;
  }

  /**
   * Disconnect Login
   */
  public disconnectLogin(): void {
    if (this.hubLoginConnection) {
      this.hubLoginConnection.stop();
      this.hubLoginConnection = null;
    }
  }

  /**
   * logged User
   */
  public loggedUser(count = 1): void {
    if (this.hubLoginConnection) {
      this.disconnectLogin();
    }
    const { userId: userIdLocal, token: tokenLocal, refreshToken: refreshTokenLocal } = this.tokenService.get();

    this.hubLoginConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${this.urlBuilder.socketSecurityUrl}/account`, {
        accessTokenFactory: () => tokenLocal,
        transport: signalR.HttpTransportType.LongPolling,
      })
      .configureLogging(signalR.LogLevel.Information)
      .build();

    this.hubLoginConnection.on('mtuser-multilogin', (data) => {
      const { userId, token } = data;
      if (userIdLocal === userId && tokenLocal.toLocaleUpperCase() !== token.toLocaleUpperCase()) {
        const componentRef = this.modalService.open(TwoOptionModalComponent, { centered: true });

        const twoOption: ITwoOptionModal = {
          title: 'account-other-device',
          message: 'message-multilogin',
          emailLogin: `${environment.emailLogin}`,
          imageKey: 'attention',
          imageType: 'icon',
        };

        componentRef.componentInstance.option = twoOption;
        componentRef.result.then((cleanSession: boolean) => {
          if (cleanSession) {
            this.cleanSession(refreshTokenLocal, userIdLocal);
          }
        });
        this.cleanSession(refreshTokenLocal, userIdLocal);
        setTimeout(() => {
          componentRef.close();
        }, 6000);
      }
    });

    this.hubLoginConnection.on('mtuser-forcelogout', (data) => {
      const { userId } = data;
      if (userIdLocal === userId) {
        const componentRef = this.modalService.open(TwoOptionModalComponent, { centered: true });

        const twoOption: ITwoOptionModal = {
          title: 'account-forced-to-logout',
          message: 'message-forcelogout',
          emailLogin: `${environment.emailLogin}`,
          imageKey: 'attention',
          imageType: 'icon',
        };

        componentRef.componentInstance.option = twoOption;
        componentRef.result.then((cleanSession: boolean) => {
          if (cleanSession) {
            this.cleanSession(refreshTokenLocal, userIdLocal);
          }
        });
        this.cleanSession(refreshTokenLocal, userIdLocal);
        setTimeout(() => {
          componentRef.close();
        }, 6000);
      }
    });

    this.hubLoginConnection.on('mtuser-multiple-forcelogout', (data) => {
      const user = data.result;
      const userFound = user.find((v) => v.userId === userIdLocal);
      if (userFound) {
        const componentRef = this.modalService.open(TwoOptionModalComponent, { centered: true });

        const twoOption: ITwoOptionModal = {
          title: 'account-forced-to-logout',
          message: 'message-forcelogout',
          emailLogin: `${environment.emailLogin}`,
          imageKey: 'attention',
          imageType: 'icon',
        };

        componentRef.componentInstance.option = twoOption;
        componentRef.result.then((cleanSession: boolean) => {
          if (cleanSession) {
            this.cleanSession(refreshTokenLocal, userIdLocal);
          }
        });
        this.cleanSession(refreshTokenLocal, userIdLocal);
        setTimeout(() => {
          componentRef.close();
        }, 6000);
      }
    });

    this.hubLoginConnection.start().catch((err) => {
      if (err.statusCode === 401) {
        this.authenticationService.cleanSession();
      } else if (count <= 3) {
        setTimeout(() => this.loggedUser(count + 1), 3000);
      }
    });
  }

  /**
   * clean Session
   */
  public cleanSession(refreshTokenLocal: string, userIdLocal: number): void {
    const url = `${this.baseUrl}/Account/Logout`;
    this.communicationSecurityService.post(url, { refreshTokenLocal, userIdLocal }).subscribe(() => {
      this.authenticationService.cleanSession();
      this.disconnectLogin();
      this.cacheService.clear();
    });
  }
}
